var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChordBMajor = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 600 600",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 27.99,
  d: "M299.37 468.94L95.92 118.99h404.63L299.37 468.94z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 21.83,
  d: "M228.49 483.09a63.2 63.2 0 1163.2 63.2 63.2 63.2 0 01-63.2-63.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 8.21,
  d: "M278.2 458.44a61.6 61.6 0 0111.64-.92c6.36.05 10.45 1.16 13.52 3.64a10.19 10.19 0 014.05 8.63c0 4.7-3.19 8.79-8.4 10.63v.14c4.68 1.19 10.15 5.07 10.11 12.29a13 13 0 01-4.22 9.72c-3.45 3.08-9 4.49-17.07 4.42a74.15 74.15 0 01-9.88-.65zm6.14 43.33a35.67 35.67 0 005.34.33c6.59 0 12.68-2.29 12.71-9.37 0-6.65-5.73-9.44-12.68-9.49h-5.27zm.12-23.34h5.78c6.73 0 10.7-3.38 10.73-8.08 0-5.71-4.35-8-10.79-8a27.79 27.79 0 00-5.64.39z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f283b2",
  stroke: "#f283b2",
  strokeMiterlimit: 10,
  strokeWidth: 8.21,
  d: "M232.33 301.82q12.69-.7 16.43-3.94t3.74-15v-93.77q0-11.64-3.74-15t-16.43-4v-3.92h59q25.31 0 40.16 8.14t14.86 28q0 14.94-10.39 22.66-5.87 4.44-17.61 7.32a63 63 0 0124.81 11.67q10.29 8.19 10.3 22.89 0 24.69-22.84 33.94-12 4.83-29.62 4.84h-68.7zm79.26-76.49Q325 219.15 325 203.16q0-18.87-15.44-25.47-8.55-3.62-25.94-3.61-6.58 0-8.13 1.13t-1.55 6.19v47.65l20.08-.31q10.56-.21 17.57-3.41zm6.79 66.51q10.92-6.29 10.92-24.09t-12.77-24.19q-12.76-6.48-32.53-6.48h-6.12c-.86 0-2.18 0-4-.11v52.5q0 5.46 3.09 7t14.31 1.6q16.18.05 27.1-6.23z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#64c083",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M567.75 115.35a61.64 61.64 0 11-61.64-61.64 61.64 61.64 0 0161.64 61.64z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#64c083",
  stroke: "#64c083",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M478.05 94.79h26.28v5.29h-20v16.21h18.46v5.22h-18.44v22.07h-6.3z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#ffd55a",
  strokeMiterlimit: 10,
  strokeWidth: 21.29,
  d: "M155.53 123.87a61.64 61.64 0 11-61.64-61.64 61.64 61.64 0 0161.64 61.64z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd55a",
  stroke: "#ffd55a",
  strokeMiterlimit: 10,
  strokeWidth: 6.51,
  d: "M59.35 104a90.22 90.22 0 0113.4-1c9 0 15.49 2.1 19.76 6.08s6.87 9.63 6.87 17.52-2.46 14.48-7 19-12.09 7-21.57 7a102.18 102.18 0 01-11.46-.6zm6.3 43.15a39.73 39.73 0 006.37.36c13.47 0 20.78-7.53 20.78-20.7.07-11.51-6.45-18.83-19.77-18.83a35.16 35.16 0 00-7.38.66z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd55a",
  stroke: "#ffd55a",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  d: "M109 137.32l1.88-14.19h-5.93v-4.27h6.58l1.38-10.5h-6.23v-4.27h6.88l1.88-13.82h4.2l-1.81 13.82h7.53l1.88-13.82h4.27l-1.81 13.82h5.94v4.27H129l-1.3 10.5h6.22v4.27h-6.87l-1.89 14.19h-4.34l1.88-14.19h-7.53l-1.88 14.19zm14.4-18.46l1.38-10.5h-7.53l-1.37 10.5z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#64c083",
  stroke: "#64c083",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  d: "M515 124.5l1.88-14.19h-5.93V106h6.58l1.38-10.5h-6.22v-4.23h6.87l1.88-13.82h4.2l-1.84 13.82h7.53l1.88-13.82h4.27l-1.81 13.82h5.94v4.27H535l-1.3 10.5h6.3v4.27h-6.88l-1.88 14.19h-4.35l1.88-14.19h-7.57l-1.89 14.19zm14.38-18.5l1.37-10.5h-7.53l-1.37 10.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChordBMajor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chord-b-major.660e3b201ddc66c2a7e043ee4c6f1522.svg";